const BASE_URL = process.env.REACT_APP_API_URL || '';

export async function checkConsent({ name, birthDate, phone }) {
  const res = await fetch(`${BASE_URL}/api/consent/check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, birthDate, phone }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || '서버 오류가 발생했습니다.');
  }
  return res.json();
}

export async function createConsent(dto) {
  const res = await fetch(`${BASE_URL}/api/consent`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dto),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || '동의 저장에 실패했습니다.');
  }
  return res.json();
}
